import { useMemo } from "react";
import { parseISO, getYear } from "date-fns";
import useFetchGraphData from "../useFetchGraphData";

export default function useYearSeries({
  locationid,
  parameterid,
  depthFilter = [],
}) {
  const {
    data,
    isFetching: isLoading,
    isError,
  } = useFetchGraphData(
    { locationid, parameterid },
    "results-simple/year-comparison"
  );

  const { series, years, depths, unit } = useMemo(() => {
    if (!data?.length) return { series: [], years: [], depths: [], unit: "" };

    // Unique depth values
    const depths = [...new Set(data.map((d) => +d.depth_value || 0))].sort(
      (a, b) => a - b
    );

    // Use all depths if none selected
    const keep = depthFilter.length ? depthFilter : depths;

    const filtered = data.filter((d) => keep.includes(+d.depth_value || 0));

    // Month-by-year aggregation
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const rows = monthNames.map((m) => ({ month: m }));
    const allYears = new Set();

    filtered.forEach((d) => {
      const y = getYear(parseISO(d.rdate));
      const mIdx = parseISO(d.rdate).getMonth();
      const currentVal = rows[mIdx][y];

      rows[mIdx][y] =
        currentVal != null
          ? (currentVal + d.rvalue_converted) / 2 // avg if duplicate
          : d.rvalue_converted;

      allYears.add(y);
    });

    return {
      series: rows,
      years: [...allYears].sort(),
      depths,
      unit: filtered[0]?.unit_name || "",
    };
  }, [data, depthFilter]);

  return { series, years, depths, unit, isLoading, isError };
}
